import React from 'react';

import {
  Popover as MuiPopover,
  PopoverProps as MuiPopoverProps,
  Box,
  IconButton,
  styled,
  useTheme,
  alpha,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import { useWindowDimensions } from '@/hooks/useWindowDimensions';

interface PopoverProps extends MuiPopoverProps {
  onClose: () => void;
}

const MobilePopover = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  position: 'fixed',
  width: '100vw',
  height: '100vh',
  top: 0,
  left: 0,
  zIndex: 1000,
  fontSize: 18,
  paddingLeft: 24,
  paddingRight: 24,
  paddingTop: 80,
  paddingBottom: 60,
  overflow: 'auto',
}));

const Popover = ({ children, open, ...props }: PopoverProps): JSX.Element | null => {
  const { width } = useWindowDimensions();
  const theme = useTheme();

  if (!open) { return null; }

  if (width <= 600) {
    return (
      <MobilePopover>
        {children}
        <IconButton
          onClick={props.onClose}
          style={{
            position: 'absolute',
            right: '16px',
            top: '16px',
          }}
        >
          <CloseIcon fontSize="medium" />
        </IconButton>
      </MobilePopover>
    );
  }

  return (
    <MuiPopover
      style={{ background: alpha(theme.palette.grey[900], 0.6) }}
      open={open}
      anchorEl={props.anchorEl || document.body}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'center',
        horizontal: 'center',
      }}
      {...props}
    >
      <Box sx={{ p: 4, maxWidth: 560, flex: 1 }}>
        {children}
        <IconButton
          onClick={props.onClose}
          style={{
            position: 'absolute',
            right: '16px',
            top: '16px',
          }}
        >
          <CloseIcon fontSize="medium" />
        </IconButton>
      </Box>
    </MuiPopover>
  );
};

export default Popover;
